import { ChatUserModel } from 'types/chat-users/chat-user';
import { MessageMediaType, MessageStatus } from 'types/chat/messages/common';
import { audioExtensionRegex } from './regexes/media';
import { TemplateVarsData } from 'types/templates/templates-menu';

import LocationOnIcon from '@mui/icons-material/LocationOn';
import MicIcon from '@mui/icons-material/Mic';
import ImageIcon from '@mui/icons-material/Image';
import PersonIcon from '@mui/icons-material/Person';
import StickyNote2Icon from '@mui/icons-material/StickyNote2';
import VideoCameraBackIcon from '@mui/icons-material/VideoCameraBack';
import FolderZipIcon from '@mui/icons-material/FolderZip';
import DescriptionIcon from '@mui/icons-material/Description';
import DoneIcon from '@mui/icons-material/Done';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { IsJsonString, safeParseJSON } from './helpers';
import { intlGlobal } from './locales_old/intlGlobal';
import { IntlShape } from 'react-intl';
import { store } from 'store';

//* Chat users
export function doesUserMatchCurrentFilters(currentUser: ChatUserModel, view: string) {
  console.log('currentUser', currentUser);
  
  const storeState = store.getState();
  const { searchQuery, label, open, isOnlyUnread, filters } = storeState.chat.chatUsersFilters;

  //* Independent filters
  const searchCond = !searchQuery?.length
    ? true
    : currentUser.UserDisplayPhoneNumber.includes(searchQuery.toLowerCase()) ||
      currentUser.FullName.toLowerCase().includes(searchQuery.toLowerCase());
  const labelCond = label && label !== '' ? currentUser.LableName === label : true;
  const openCond =
    open === 'open' ? currentUser.IsOpen === true : open === 'close' ? currentUser.IsOpen === false : true;
  const onlyUnreadCond = isOnlyUnread ? (currentUser.UnreadMessagesNumber ?? 0) > 0 : true;

  //* Filters, related to views
  let assigneeFilter: Array<string | null> = [];
  if (view === 'notMyChatUsers') {
    assigneeFilter = storeState.applicationUsers
      .filter((user) => {
        const userProfileConfig = safeParseJSON(user.ProfileConfig);

        const visible =
          userProfileConfig?.funnerInfo?.visibleInList !== undefined &&
          userProfileConfig?.funnerInfo?.visibleInList !== null
            ? userProfileConfig.funnerInfo.visibleInList
            : user.IsActive;

        return visible && storeState.user!.Udid !== user.Udid;
      })
      .map((user) => user.Udid);
  }

  //* Bots users view
  const isBot = view === 'botsChatUsers';

  //* My users view
  const isMyCond =
    view === 'myChatUsers' ? currentUser.NotificationContactUser === storeState.user?.Udid : true;

  const assigneeFilterCond = assigneeFilter.length
    ? assigneeFilter.includes(currentUser.NotificationContactUser ?? '')
    : view === 'unassignedChatUsers'
      ? !currentUser.NotificationContactUser
      : true;
  const botCond =
    currentUser.isBot === null || currentUser.isBot === undefined
      ? isBot === false
      : currentUser.isBot === isBot;

  //* Additional filters (custom views)
  const additionalFiltersCond = doesUserMatchAdditionalFilters(filters ?? [], currentUser);

  return (
    searchCond &&
    labelCond &&
    openCond &&
    onlyUnreadCond &&
    assigneeFilterCond &&
    botCond &&
    isMyCond &&
    additionalFiltersCond
  );
}

export function doesUserMatchAdditionalFilters(filters: any[], user: ChatUserModel) {
  if (!filters || !user) return true;
  console.log('filters', filters);
  for (const filter of filters.filter((f) => f.value != null)) {
    const key = filter.key;
    let value = filter.value;

    console.log('key additional filters', key);
    console.log('value additional filters', value);
    console.log('user', user);
    switch (key) {
      case 'IsOpen':
        if (user.IsOpen !== Boolean(value)) {
          return false;
        }
        break;
      case 'IsOpenUpdateTimeFrom':
        if (user.OpenTime && new Date(user.OpenTime) <= new Date(value)) {
          return false;
        }
        break;
      case 'IsOpenUpdateTimeTo':
        if (user.OpenTime && new Date(user.OpenTime) >= new Date(value)) {
          return false;
        }
        break;
      case 'NotificationContactUser':
        if (!Array.isArray(value)) {
          value = [value];
        }
        if (!value.includes(user.NotificationContactUser)) {
          return false;
        }
        break;
      case 'LableName':
        console.log('user.LableName', user.LableName);
        console.log('value', value);
        if (user.LableName !== String(value)) {
          return false;
        }
        break;
      case 'LastMessageMediaType':
        if (user.LastMessageMediaType !== String(value)) {
          return false;
        }
        break;
      case 'LastMessageIsImage':
        if (value === true && user.LastMessageMediaType !== 'image') {
          return false;
        }
        break;
      case 'LastMessageIsVideo':
        if (value === true && user.LastMessageMediaType !== 'video') {
          return false;
        }
        break;
      case 'LastMessageIsAudio':
        if (value === true && user.LastMessageMediaType !== 'audio') {
          return false;
        }
        break;
      case 'LastMessageSource':
        if (user.LastMessageSource !== String(value)) {
          return false;
        }
        break;
      case 'IncomingLastMessageMediaType':
        if (user.IncomingLastMessageMediaType !== String(value)) {
          return false;
        }
        break;
      case 'IncomingLastMessageDateFrom':
        if (user.IncomingLastMessageDate && new Date(user.IncomingLastMessageDate) <= new Date(value)) {
          return false;
        }
        break;
      case 'IncomingLastMessageDateTo':
        if (user.IncomingLastMessageDate && new Date(user.IncomingLastMessageDate) >= new Date(value)) {
          return false;
        }
        break;
      case 'IncomingLastMessageIsImage':
        if (value === true && user.IncomingLastMessageMediaType !== 'image') {
          return false;
        }
        break;
      case 'IncomingLastMessageIsVideo':
        if (value === true && user.IncomingLastMessageMediaType !== 'video') {
          return false;
        }
        break;
      case 'IncomingLastMessageIsAudio':
        if (value === true && user.IncomingLastMessageMediaType !== 'audio') {
          return false;
        }
        break;
      case 'IncomingLastMessageSource':
        if (user.IncomingLastMessageSource !== String(value)) {
          return false;
        }
        break;
      case 'IncomingLastMessageContactUser':
        if (!Array.isArray(value)) {
          value = [value];
        }
        if (!value.includes(user.IncomingLastMessageContactUser)) {
          return false;
        }
        break;
      case 'OutcomingLastMessageMediaType':
        if (user.OutgoingLastMessageMediaType !== String(value)) {
          return false;
        }
        break;
      case 'OutcomingLastMessageDateFrom':
        if (user.OutcomingLastMessageDate && new Date(user.OutcomingLastMessageDate) <= new Date(value)) {
          return false;
        }
        break;
      case 'OutcomingLastMessageDateTo':
        if (user.OutcomingLastMessageDate && new Date(user.OutcomingLastMessageDate) >= new Date(value)) {
          return false;
        }
        break;
      case 'OutcomingLastMessageIsImage':
        if (value === true && user.OutgoingLastMessageMediaType !== 'image') {
          return false;
        }
        break;
      case 'OutcomingLastMessageIsVideo':
        if (value === true && user.OutgoingLastMessageMediaType !== 'video') {
          return false;
        }
        break;
      case 'OutcomingLastMessageIsAudio':
        if (value === true && user.OutgoingLastMessageMediaType !== 'audio') {
          return false;
        }
        break;
      case 'OutcomingLastMessageSource':
        if (user.OutgoingLastMessageSource !== String(value)) {
          return false;
        }
        break;
      default:
        break;
    }
  }

  return true;
}

export const getMessageStatus = (newStatus: MessageStatus, oldStatus: MessageStatus) => {
  return (newStatus === 'pending system' &&
    (oldStatus === 'sent' || oldStatus === 'delivered' || oldStatus === 'read')) ||
    (newStatus === 'sent' && (oldStatus === 'delivered' || oldStatus === 'read')) ||
    (newStatus === 'delivered' && oldStatus === 'read')
    ? oldStatus
    : newStatus;
};
export const filterUnreadChatUsersByView = (
  unreadChatUsers: ChatUserModel[],
  userId: string | undefined,
  viewId: 'my-chats' | 'not-my-chats' | 'unassigned-chats' | 'bots-chats' | 'chats' | undefined,
) => {
  return unreadChatUsers.filter((user) => {
    switch (viewId) {
      case 'my-chats':
        return user.NotificationContactUser === userId;
      case 'not-my-chats':
        return user.NotificationContactUser && user.NotificationContactUser !== userId;
      case 'unassigned-chats':
        return user.NotificationContactUser === null || user.NotificationContactUser === undefined;
      case 'bots-chats':
        return user.isBot;
      case 'chats':
      default:
        return true;
    }
  });
};
//* Messages
export const messageTypesByFormat: {
  [key: string]: Array<MessageMediaType | null | undefined>;
} = {
  doc: ['document', 'docx', 'doc', 'msword', 'pdf', 'xlsx', 'xls', 'zip'],
  image: ['image', 'gif', 'sticker'],
  video: ['video'],
};

export const getIsImageMessage = (
  fileType?: MessageMediaType | null,
  mediaNoteFormat?: MessageMediaType | null,
  file?: string | null,
) => {
  return Boolean(
    messageTypesByFormat.image.includes(fileType) ||
      messageTypesByFormat.image.includes(mediaNoteFormat) ||
      (file?.includes('data:image') ?? false) ||
      fileType?.match(/(png|jpe?g|gif)$/i),
  );
};
export const getIsVideoMessage = (
  fileType?: MessageMediaType | null,
  mediaNoteFormat?: MessageMediaType | null,
  file?: string | null,
) => {
  return (
    messageTypesByFormat.video.includes(fileType) ||
    messageTypesByFormat.video.includes(mediaNoteFormat) ||
    fileType?.match(/(mp4|webm|avi|mov|mkv|flv|wmv)$/i)
  );
};
export const getIsDocMessage = (
  fileType?: MessageMediaType | null,
  mediaNoteFormat?: MessageMediaType | null,
  file?: string | null,
) => {
  return (
    messageTypesByFormat.doc.includes(fileType) ||
    messageTypesByFormat.doc.includes(mediaNoteFormat) ||
    fileType === 'document' ||
    mediaNoteFormat === 'document'
  );
};
export const getIsAudioMessage = (
  fileType?: MessageMediaType | null,
  mediaNoteFormat?: MessageMediaType | null,
) => {
  return (
    fileType === 'audio' ||
    mediaNoteFormat === 'audio' ||
    audioExtensionRegex.test(fileType as string) ||
    audioExtensionRegex.test(mediaNoteFormat as string)
  );
};

//* Templates
export const checkIsTemplateValidWithVarsData = (varsData: TemplateVarsData, skipMedia?: boolean) => {
  let result: {
    valid: boolean;
    details: {
      [keyof in TemplateVarsData[0]['name']]?: boolean;
    };
  } = {
    valid: false,
    details: {},
  };

  try {
    const errorsObj: {
      [keyof in TemplateVarsData[0]['name']]?: boolean;
    } = {};
    varsData.forEach((param) => {
      errorsObj[param.name] = param.name === 'data' && skipMedia ? false : param.text === '';
    });

    result = {
      valid: !Object.values(errorsObj).includes(true),
      details: errorsObj,
    };
  } catch (error) {
    console.warn('checkIsTemplateValid error: ', error);
  }

  return result;
};

//* message preview
export const fileTypes = ['pdf', 'xlsx', 'xls', 'docx', 'doc', 'pdf'];
export const iconStyle = { width: 14, height: 14, color: 'grey.800' };
export const mediaTypeIconMap: Record<string, React.ElementType> = {
  location: LocationOnIcon,
  audio: MicIcon,
  image: ImageIcon,
  contacts: PersonIcon,
  template: StickyNote2Icon,
  video: VideoCameraBackIcon,
  zip: FolderZipIcon,
};
export const getMediaIcon = (mediaType?: string | null) => {
  if (!mediaType) return null;

  const lowerMediaType = mediaType.toLowerCase();
  // If type exists – return existing icon
  if (mediaTypeIconMap[lowerMediaType]) {
    const IconComponent = mediaTypeIconMap[lowerMediaType];
    return <IconComponent sx={iconStyle} />;
  }
  if (fileTypes.includes(lowerMediaType)) {
    return <DescriptionIcon sx={iconStyle} />;
  }
  return null;
};

export const getOutcomingIcon = (status?: string | null) => {
  if (!status) return null;

  // 'played' = voice note שהושמע ע"י הנמען (status ייחודי של WhatsApp ל-PTT, לא שגיאה).
  const validStatuses = ['sent', 'delivered', 'read', 'played', 'pending whatsapp', 'pending system', 'sending', 'uploading'];
  const statusLower = status.toLowerCase();
  
  // Check if status is valid
  if (validStatuses.includes(statusLower)) {
    switch (statusLower) {
    case 'sent':
      return <DoneIcon sx={iconStyle} />;
    case 'delivered':
      return <DoneAllIcon sx={iconStyle} />;
    case 'read':
    case 'played':
      // ויזואלית זהה ל-'read' (אותה צורה כמו ב-WhatsApp רשמי).
      return <DoneAllIcon sx={{ ...iconStyle, color: 'secondary.main' }} />;
      case 'pending whatsapp':
      case 'pending system':
      case 'sending':
      case 'uploading':
        // Return null for pending/loading states in list view
        return null;
    default:
      return null;
  }
  }
  
  // If status is an error (not in valid statuses), show error icon
  return <ErrorOutlineIcon sx={{ ...iconStyle, color: 'error.main' }} />;
};
export const getMessagePreviewText = (user: ChatUserModel, intl?: IntlShape) => {
  if (user.LastMessageMediaType === 'template' && IsJsonString(user.LastMessage)) {
    const parsed = safeParseJSON(user.LastMessage);
    return parsed?.['BODY']?.text || '';
  }
  if (user.LastMessage === 'image') return (intl || intlGlobal).formatMessage({ id: 'chat.messages.image' });
  if (user.LastMessage === 'buttons')
    return (intl || intlGlobal).formatMessage({ id: 'chat.messages.buttons' });
  return user.LastMessage || '';
};
export const getSingleMessagePreviewText = (
  mediaType: MessageMediaType,
  message: string,
  intl?: IntlShape,
) => {
  if (mediaType === 'template' && IsJsonString(message)) {
    const parsed = safeParseJSON(message);
    return parsed?.['BODY']?.text || '';
  }
  if (mediaType === 'image' && message === '')
    return (intl || intlGlobal).formatMessage({ id: 'chat.messages.image' });
  if (mediaType === 'buttons' && message === '')
    return (intl || intlGlobal).formatMessage({ id: 'chat.messages.buttons' });
  return message || '';
};
